import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0;
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22px;
  padding: 30px 24px 26px;
  background:
    linear-gradient(180deg, rgba(239, 243, 250, 0.94) 0%, rgba(233, 239, 247, 0.96) 100%);
  border-bottom: 1px solid rgba(182, 194, 214, 0.35);
`

export const HeaderTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 8px;
`

export const StepEyebrow = styled.span`
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #6b86a1;
`

export const StepDescription = styled.p`
  margin: 0;
  max-width: 760px;
  font-size: 15px;
  line-height: 1.55;
  color: #61748a;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: auto;
  padding: 28px 36px 0;

  @media (max-width: 900px) {
    padding: 20px 20px 0;
  }
`

export const SelectorsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 28px;
`

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  margin-top: 22px;
  padding: 0 0 12px;

  @media (max-width: 900px) {
    align-items: stretch;
    flex-direction: column-reverse;
    gap: 16px;
  }
`

export const IntroBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const IntroTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  line-height: 1.3;
  font-weight: 700;
  color: #243b53;
`

export const IntroText = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #627d98;
`

export const OptionsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;

  @media (max-width: 1400px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
  }
`

export const OptionCard = styled.button<{ $selected?: boolean; $accent?: 'pink' | 'blue' | 'slate' }>`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
  width: 100%;
  min-height: 174px;
  padding: 24px 24px 22px;
  border-radius: 24px;
  border: 1.5px solid
    ${({ $selected, $accent }) => {
      if ($selected && $accent === 'pink') return '#f0077b'
      if ($selected && $accent === 'blue') return '#3e7da6'
      if ($selected) return '#7c96b2'
      return '#d7e5f4'
    }};
  background:
    ${({ $selected, $accent }) => {
      if ($selected && $accent === 'pink') {
        return 'linear-gradient(180deg, rgba(255, 241, 248, 0.98) 0%, rgba(255, 249, 252, 0.98) 100%)'
      }
      if ($selected && $accent === 'blue') {
        return 'linear-gradient(180deg, rgba(241, 248, 255, 0.98) 0%, rgba(250, 252, 255, 0.98) 100%)'
      }
      if ($selected) {
        return 'linear-gradient(180deg, rgba(245, 249, 255, 0.98) 0%, rgba(252, 253, 255, 0.98) 100%)'
      }
      return '#ffffff'
    }};
  box-shadow:
    ${({ $selected, $accent }) => {
      if ($selected && $accent === 'pink') return '0 18px 40px rgba(240, 7, 123, 0.14)'
      if ($selected && $accent === 'blue') return '0 18px 40px rgba(62, 125, 166, 0.14)'
      if ($selected) return '0 18px 40px rgba(65, 84, 112, 0.12)'
      return '0 12px 26px rgba(36, 59, 83, 0.06)'
    }};
  text-align: left;
  cursor: pointer;
  transition: transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 20px 44px rgba(36, 59, 83, 0.12);
  }
`

export const OptionEyebrow = styled.span`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #6c86a3;
`

export const OptionHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`

export const OptionTitle = styled.h4`
  margin: 0;
  font-size: 20px;
  line-height: 1.25;
  font-weight: 700;
  color: #243b53;
`

export const OptionDescription = styled.p`
  margin: 0;
  font-size: 15px;
  line-height: 1.6;
  color: #627d98;
`

export const OptionMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const OptionBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, #f0077b 0%, #bf0c8c 100%);
  box-shadow: 0 10px 24px rgba(240, 7, 123, 0.24);
  color: #ffffff;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`

export const OptionIndicator = styled.span<{ $selected?: boolean; $accent?: 'pink' | 'blue' | 'slate' }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid
    ${({ $selected, $accent }) => {
      if ($selected && $accent === 'pink') return '#f0077b'
      if ($selected && $accent === 'blue') return '#3e7da6'
      if ($selected) return '#7c96b2'
      return '#79a8d8'
    }};
  background:
    ${({ $selected, $accent }) => {
      if (!$selected) return '#ffffff'
      if ($accent === 'pink') return 'radial-gradient(circle, #ffffff 0 28%, #f0077b 30% 100%)'
      if ($accent === 'blue') return 'radial-gradient(circle, #ffffff 0 28%, #3e7da6 30% 100%)'
      return 'radial-gradient(circle, #ffffff 0 28%, #7c96b2 30% 100%)'
    }};
  box-shadow: ${({ $selected }) => ($selected ? '0 0 0 6px rgba(240, 7, 123, 0.12)' : 'none')};
  flex-shrink: 0;
`

export const CopyBlock = styled.div`
  width: 100%;
  max-width: 440px;
  margin-top: 8px;
`

export const OptionSupportBlock = styled.div`
  width: 100%;
  max-width: 440px;
  margin-top: -2px;
`
